module.exports = __webpack_public_path__ + "frontend/images/gold/carousel/globe.png?ed1454bd0f3abae8dfc92d576dd74d28";